/**
 * Mila Design Studio - Constantes globales de la aplicación
 */

/**
 * Normaliza un número telefónico argentino para enlaces directos de WhatsApp (wa.me).
 * Convierte formatos locales como '1159265776' en formato internacional '5491159265776'.
 */
export function formatWhatsAppNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (!digits) return '5491159265776';
  if (digits.startsWith('549')) return digits;
  if (digits.startsWith('54')) return `549${digits.slice(2)}`;
  return `549${digits}`;
}

// Número oficial de atención por WhatsApp de Mila Design
// Por defecto 1159265776 (formateado a 5491159265776 para la API de WhatsApp)
export const STORE_WHATSAPP_RAW = import.meta.env.VITE_WHATSAPP_NUMBER || '1159265776';
export const STORE_WHATSAPP_NUMBER = formatWhatsAppNumber(STORE_WHATSAPP_RAW);
